module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"suggestions":{"title":"You may also like"}},"de":{"suggestions":{"title":"Das könnte Ihnen auch gefallen"}}}')
  delete Component.options._Ctor
}
